import { combineReducers } from '@reduxjs/toolkit';

import chatWidgetSlice from './chatWidgetSlice';
import chatWindowSlice from './chatWindowSlice';

export const CHAT_REDUCER_PATH = 'chat' as const;

export const chatReducers = combineReducers({
  chatWindow: chatWindowSlice,
  chatWidget: chatWidgetSlice,
});

export const chatActions = {};

export interface RootState {
  [CHAT_REDUCER_PATH]: ReturnType<typeof chatReducers>;
}
